import { useState } from 'react';
import Collapsible from 'src/components/Collapsible/Collapsible';
import DropdownUi from 'src/components/primitives/DropdownUi/DropdownUi';
import { AccountData } from 'src/stores/useDriftAccountsStore';
import { cj } from 'src/utils/classNames';
import { VaultDepositorData } from 'src/hooks/query/vaults/types';
import { SubAccountItem } from './SubAccountItem';
import { VaultItem } from './VaultItem';
import { InsuranceFundItem } from './InsuranceFundItem';
import {
	IFStakeItem,
	isAccountData,
	isVaultData,
	isIFStakeData,
} from './types';

export type { IFStakeItem } from './types';

const ChildrenAccounts = ({
	items,
}: {
	items: (AccountData | VaultDepositorData | IFStakeItem)[];
}) => {
	return (
		<div className="flex flex-col overflow-hidden rounded-sm border border-stroke-divider [&>:not(:last-child)]:border-b [&>:not(:last-child)]:border-stroke-divider">
			{items.map((item) => {
				if (isAccountData(item)) {
					return <SubAccountItem key={item.userKey} account={item} />;
				} else if (isVaultData(item)) {
					return <VaultItem key={item.vault.pubkey.toString()} vault={item} />;
				} else if (isIFStakeData(item)) {
					return <InsuranceFundItem key={item.marketIndex} item={item} />;
				}
				return null;
			})}
		</div>
	);
};

export const CollapsibleAccounts = ({
	title,
	items,
	showChildrenDirectly,
	highlighted,
}: {
	title: string;
	items: (AccountData | VaultDepositorData | IFStakeItem)[];
	showChildrenDirectly?: boolean;
	highlighted?: boolean;
}) => {
	const [isOpen, setIsOpen] = useState(!!highlighted);

	if (showChildrenDirectly) {
		return <ChildrenAccounts items={items} />;
	}

	return (
		<Collapsible.Root open={isOpen} onOpenChange={setIsOpen}>
			<Collapsible.Trigger asChild>
				<DropdownUi.Trigger
					data-state={isOpen ? 'open' : 'closed'}
					className={cj(
						'w-full',
						highlighted ? 'bg-button-disabled' : 'bg-input-bg'
					)}
					valueClassName={cj(
						'text-text-default',
						highlighted ? 'text-purple-link' : 'text-text-default'
					)}
				>
					{title}
					<div className="text-text-default">
						<DropdownUi.Chevron />
					</div>
				</DropdownUi.Trigger>
			</Collapsible.Trigger>

			<Collapsible.Content className="mt-sm">
				<ChildrenAccounts items={items} />
			</Collapsible.Content>
		</Collapsible.Root>
	);
};
